import { Box, styled } from "@mui/material";
import { AppIconsArrow } from "../../AppIcons";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";


export const BoxSummaryBasketStyled = styled(Box, {
    label: "basketdetailCollapsible_box",
})(({ theme }) => ({
    backgroundColor: "#fff",
    minHeight: 60,
    display: "flex",
    //boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
    boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.2)',
    borderTop: '1px solid ' + StyleguideSavioColors.mainBlue,
    marginTop: "20px",
    marginBottom: 10,
    cursor: "pointer",
    alignItems: "center",
    

    ' *': {
        boxShadow: 'none !important',
    },
    '.MuiPaper-root': {
        width: "100%"
    },
    '> div:first-of-type > div': {
        borderTop: 0,

        'table': {
            marginRight: 10,
        }
    },

    '+ div': {
        //qua sono dentro la tabella

        height: 'auto',
        '> div': {
            //maxHeight: 330,
            
            //levo lo scroll della tabella, di conseguenza tutta la popup è scrollabile
            height: 'auto',
'table + div':{
    display: 'none',
},
        },
     
        'td.codeDescription ': {
           
            'button': {
                padding: 3,
                marginRight: 5

            }
        },
        'td.noteItems ':{
            'button':{
                color: StyleguideSavioColors.mainBlue,
            },
            'svg.noNote':{
                color: StyleguideSavioColors.text.black,
               // opacity: 0.4,
            }
        },
        'td.qty ':{
            '> div > div':{
                justifyContent: 'center',

                'div':{
                    width: 'auto',
                }
            }
        },


       
    },

    
}));

export const IconsArrowStyled = styled(AppIconsArrow, {
    label: "basketdetailCollapsible_arrow",
})(({ theme }) => ({
    fontSize: 11,
    color: "#000",
    cursor: "pointer",
}));
